/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetStakingHistoryQueryVariables = Types.Exact<{
	filter?: Types.InputMaybe<Types.StakingHistoryFilter>;
}>;

export type GetStakingHistoryQuery = {
	__typename?: "Query";
	history: Array<{
		__typename?: "StakingAction";
		id: string;
		walletId?: string | null;
		type: Types.StakingActionType;
		asset: { __typename?: "StakeableAsset"; assetId: string };
		assetAmount: { __typename?: "CurrencyAmount"; value: string };
		createdAt: { __typename?: "DateTime"; iso8601: string };
	}>;
};

export const GetStakingHistoryDocument = gql`
	query getStakingHistory($filter: StakingHistoryFilter) {
		history(filter: $filter) {
			id
			asset {
				assetId
			}
			walletId
			type
			assetAmount {
				value
			}
			createdAt {
				iso8601
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class GetStakingHistoryGQLService extends Apollo.Query<GetStakingHistoryQuery, GetStakingHistoryQueryVariables> {
	document = GetStakingHistoryDocument;
	client = "staking";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
